<script>
export default {
  data() {
    return {
      switchCost: 'year',
      list: [
        {
          img: require('@assets/images/plan/basic.svg'),
          title: '初階方案',
          year: {
            money: '$41,600',
            count: '起/年',
            starPlan: ['初階預約系統方案','專業行銷顧問團隊','店門形象拍攝','行銷設計','本地商家資訊建置','系統輔助轉型2個月',],
          },
          halfYear: {
            money: ' $33,600',
            count: '起/半年',
            starPlan: ['初階預約系統方案','專業行銷顧問團隊','店門形象拍攝','行銷設計','本地商家資訊建置','系統輔助轉型1個月',],
          },
          
          to:"marketingplan"
        },
        {
          img: require('@assets/images/plan/add-on.svg'),
          title: '進階方案',
          year: {
            money: '$59,600',
            count: '起/年',
            starPlan: ['進階預約系統方案',`專業行銷顧問團隊`,'店門形象拍攝','行銷設計','本地商家資訊建置','系統輔助轉型2個月',],
          },
          halfYear: {
            money: '$42,600',
            count: '起/半年',
            starPlan: ['進階預約系統方案',`專業行銷顧問團隊`,'店門形象拍攝','行銷設計','本地商家資訊建置','系統輔助轉型1個月',],
          },
          to:"marketingplan"
        },
        {
          img: require('@assets/images/plan/intermediate.svg'),
          title: '客製化方案',
          year: {
            money: '$依功能制定',
            count: null,
            starPlan: [`客製化方案<br>依據您的營運狀況，提供最適合的服務組合`,'進階預約系統方案','專業行銷顧問團隊','店門面形象拍攝','行銷設計','廣告投放','營運諮詢與發展推廣','拓點與營運管理諮詢'],
          },
          halfYear: {
            money: '$依功能制定',
            count: null,
            starPlan: [`客製化方案<br>依據您的營運狀況，提供最適合的服務組合`,'進階預約系統方案','專業行銷顧問團隊','店門面形象拍攝','行銷設計','廣告投放','營運諮詢與發展推廣','拓點與營運管理諮詢'],
          },
          // to:''
        },
      ],
    }
  },
  methods: {
    handleClick(tab, event) {

    },
    setPlanMoney(item) {
      if (this.switchCost === 'halfYear') {
        return item.halfYear
      }else {
        return item.year
      }
    }
  },
}
</script>

<template>
  <div :class="$style.sectionMarketingPlan">
    <div class="section">
      <div class="container">
        <div class="sectionMarketingPlan__toggle">
          <BaseSectionTitle 
            title="系統行銷整合方案" 
            sub-title="Integrated Marketing" 
            class="isStyleDecoration text-lg-left text-center islgCenter mx-lg-0 mx-auto mb-md-0"
          />
          <el-tabs 
            v-model="switchCost" 
            stretch 
            class="isStyleBase isBigWidth"
            @tab-click="handleClick"
          >
            <el-tab-pane label="年繳" name="year"></el-tab-pane>
            <el-tab-pane label="半年繳" name="halfYear"></el-tab-pane>
          </el-tabs>
          
        </div>
        <div class="row">
          <div
            v-for="(item, $index) in list"
            :key="$index"
            class="col-lg-4 col-12 sectionMarketingPlan__item"
          >
            <BasePlan 
              :img="item.img"
              :title="item.title"
              :money=setPlanMoney(item)
              :list="item[switchCost].plan"
              :star-list="item[switchCost].starPlan"
              is-show-contact
              :to="item.to"
            />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<style lang="scss" module>
  .sectionMarketingPlan {
    position: relative;
    z-index: 3;
    @include max-lg {
      top: 0;
      padding-top: 100px;
    }
    &:after {
      content:'';
      position: absolute;
      background-image: url('@assets/images/plan/paw-1.svg');
      background-repeat: no-repeat;
      background-size: cover;
      width: 9%;
      padding-bottom: 11%;
      top: 3rem;
      right: 0;
      @include max-lg {
        display: none;
      }
    }
    :global {
      .sectionMarketingPlan {
        &__toggle {
          // margin-top: 60px;
          margin-bottom: 10rem;
          display: flex;
          justify-content: space-between;
          align-items: center;
          @include max-lg {
            margin-bottom: 20px;
          }
          @include max-md {
            flex-direction: column;
          }
        }
        &__item {
          position: relative;
          z-index: 3;
          @include max-lg {
             margin-top: 110px;
          }
        }
        &__content {
          margin-top: 30px;
          margin-bottom: 100px;
          font-size: 14px;
          color: $color-text-2;
          line-height: 1.75;
        }
      }
      .el-tabs__nav-wrap {
        margin-left: auto;
        @include max-lg {
          margin: 0 auto;
        }
      }
    }
  }
</style>